/**
 * API client that automatically includes the auth token in all requests.
 * Use this for all API calls that require authentication.
 */
import { API_URL } from '../config';

/**
 * Fetch with auth token. Drops Content-Type for FormData.
 */
export const apiFetch = (url, options = {}) => {
    const token = localStorage.getItem('token');
    const headers = { ...(options.headers || {}) };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    if (!(options.body instanceof FormData)) {
        headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    } else {
        delete headers['Content-Type'];
    }
    return fetch(url, { ...options, headers });
};

export const API_BASE = `${API_URL}/api`;
